import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { findAll } from "highlight-words-core";

import { highlightedNonActive, highlightedActive } from "./styles/HighlightedText.module.scss";

const highlightingClassName = ({ activeIndex, highlightIndex }) => {
  return activeIndex === highlightIndex ? highlightedActive : highlightedNonActive;
};

const HighlightedText = ({ text, searchTextPhrases, activeIndex }) => {
  const activeIndexRef = useRef();

  useEffect(() => {
    if (activeIndexRef.current) {
      activeIndexRef.current.scrollIntoView({ block: "center" });
    }
  });

  let highlightIndex = -1;
  // findAll returns an array of hashes that represent text from textToHighlight that are
  // either highlighted or not highlighted based on if they matched any of the searchWords.
  const chunks = findAll({ searchWords: searchTextPhrases, textToHighlight: text });

  return (
    <p className="m-0">
      {chunks.map(({ start, end, highlight }) => {
        highlightIndex += highlight ? 1 : 0;

        const highlightClassName = highlight ? highlightingClassName({ activeIndex, highlightIndex }) : "";
        const refParam = highlightClassName === highlightedActive ? { ref: activeIndexRef } : {};

        return (
          <span key={`chunk-${start}`} className={highlightClassName} {...refParam} >
            {text.substring(start, end)}
          </span>
        );
      })}
    </p>
  );
};

HighlightedText.propTypes = {
  text: PropTypes.string.isRequired,
  searchTextPhrases: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeIndex: PropTypes.number
};

export default HighlightedText;
